import { VarIncident, VarResult, VarStatus } from '../types';

export const varInfoMapping: Record<
  string,
  [status?: VarStatus, incident?: VarIncident, result?: VarResult, isSilentCheck?: boolean]
> = {
  '1_0': [VarStatus.SILENT_CHECK, null, VarResult.NONE],
  '2_0': [VarStatus.OFFICIAL_REVIEW, null, VarResult.NONE],
  '3_0': [VarStatus.CONFIRMED, VarIncident.PENALTY_KICK, VarResult.NONE],
  '3_1': [VarStatus.CONFIRMED, VarIncident.GOAL],
  '3_2': [VarStatus.CONFIRMED, VarIncident.NO_GOAL],
  '3_3': [VarStatus.CONFIRMED, VarIncident.PENALTY],
  '3_4': [VarStatus.CONFIRMED, VarIncident.NO_PENALTY],
  '3_7': [VarStatus.CONFIRMED, VarIncident.RED_CARD],
  '3_8': [VarStatus.CONFIRMED, VarIncident.NO_RED_CARD],
  '3_9': [VarStatus.CONFIRMED, VarIncident.PENALTY_KICK, VarResult.PENALTY_RETAKEN],
  '3_11': [VarStatus.CONFIRMED, VarIncident.PENALTY_KICK, VarResult.INDIRECT_KICK],
  '3_12': [VarStatus.CONFIRMED, VarIncident.GENERIC],
  '4_1': [VarStatus.CHANGED, VarIncident.NO_GOAL, VarResult.GOAL],
  '4_2': [VarStatus.CHANGED, VarIncident.GOAL, VarResult.NO_GOAL],
  '4_3': [VarStatus.CHANGED, VarIncident.NO_PENALTY, VarResult.PENALTY],
  '4_4': [VarStatus.CHANGED, VarIncident.PENALTY, VarResult.NO_PENALTY],
  '4_5': [VarStatus.CHANGED, VarIncident.NO_RED_CARD, VarResult.FOUL],
  '4_6': [VarStatus.CHANGED, VarIncident.NO_RED_CARD, VarResult.YELLOW_CARD],
  '4_7': [VarStatus.CHANGED, VarIncident.NO_RED_CARD, VarResult.RED_CARD],
  '4_8': [VarStatus.CONFIRMED, VarIncident.NO_RED_CARD],
  '4_10': [VarStatus.CHANGED, VarIncident.PENALTY_KICK, VarResult.NO_OFFENCE],
  '4_12': [VarStatus.CHANGED, VarIncident.GENERIC, VarResult.MISTAKEN_IDENTITY],
};
